<template>
  <a-form-field
    :id="`${id}-1`"
    :label="label"
    :label-after="labelAfter"
    :help="help"
    :has-error="hasError"
    :errors="errors"
  >
    <template slot-scope="slotProps">

      <ul
        :aria-describedby="slotProps.describedby"
        class="form-rating"
      >

        <li
          v-for="n in max"
          :key="n"
          class="form-rating__item"
        >
          <input
            ref="input"
            :aria-invalid="hasError ? 'true' : 'false'"
            :checked="value === n"
            :id="`${id}-${n}`"
            :name="id"
            :value="n"
            class="form-rating__input sr-only"
            type="radio"
            @change="$emit('input', n)"
          >
          <label
            :aria-label="`${n} ${n === 1 ? 'Stern' : 'Sterne'}`"
            :class="{ 'is-highlighted': n <= value }"
            :for="`${id}-${n}`"
            class="form-rating__label"
          />
        </li>

      </ul>

    </template>
  </a-form-field>
</template>

<script>
import AFormField from '@/components/form/atoms/AFormField'

export default {
  name: 'AFormRating',

  components: {
    AFormField
  },

  props: {
    errors: {
      type: Array
    },
    hasError: {
      type: Boolean
    },
    help: {
      type: String
    },
    id: {
      type: String,
      required: true
    },
    isValid: {
      type: Boolean
    },
    label: {
      type: String,
      required: true
    },
    labelAfter: {
      type: String
    },
    max: {
      type: Number,
      default: 5
    },
    value: {
      type: Number,
      default: 0,
      validator (value) {
        return value >= 0
      }
    }
  },

  methods: {
    /**
     * Programatically set focus
     */
    focus () {
      this.$refs.input[0].focus()
    }
  }
}
</script>

<style scoped>
.form-rating {
  list-style: none;

  display: flex;
  margin: 0;
  padding: 0;
}

.form-rating.has-error::after,
.form-rating.is-valid::after {
  content: "";

  display: block;
  width: 32px;
  height: 32px;
  margin-left: 5px;

  background: center / 20px no-repeat;
}

.form-rating.has-error::after {
  background-image: url("~@/assets/form-error.svg");
}

.form-rating.is-valid::after {
  background-image: url("~@/assets/form-success.svg");
}

.form-rating__label {
  display: block;
  width: 32px;
  height: 32px;

  background: url("~@/assets/form-star-empty.svg") center / 26px no-repeat;

  transition: background-image 200ms;
}

.form-rating__input:focus + .form-rating__label {
  outline: 2px dotted var(--color-brand);
  outline-offset: 2px;
}

.form-rating__label.is-highlighted {
  background-image: url("~@/assets/form-star-full.svg");
}
</style>
